import { render, staticRenderFns } from "./DesignDetail.vue?vue&type=template&id=ae5fb344&scoped=true&"
import script from "./DesignDetail.vue?vue&type=script&lang=js&"
export * from "./DesignDetail.vue?vue&type=script&lang=js&"
import style0 from "./DesignDetail.vue?vue&type=style&index=0&id=ae5fb344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5fb344",
  null
  
)

export default component.exports